import axios from "axios";

export const getThemes = async (body) => {
  try {
    const res = await axios.post("/api/v1/themeManagement/getThemes", body);
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getTheme = async (body) => {
  try {
    const res = await axios.post("/api/v1/themeManagement/getTheme", body);
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const createTheme = async (body) => {
  try {
    const res = await axios.post("/api/v1/themeManagement/createTheme", body);
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const copyTheme = async (body) => {
  try {
    const res = await axios.post("/api/v1/themeManagement/copyTheme", body);
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const updateTheme = async (body) => {
  try {
    const res = await axios.post("/api/v1/themeManagement/updateTheme", body);
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const deleteTheme = async (body) => {
  try {
    const res = await axios.post("/api/v1/themeManagement/deleteTheme", body);
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
